Language = require('@trello/locale')
{ supportedLocales } = require '@trello/locale'
t = require('views/internal/teacup-with-helpers')()
View = require 'view'

module.exports = class ChangeLocaleView extends View
  viewTitleKey: 'change locale'
  events:
    'click .js-select-locale': (e) ->
      @selectLocale e.currentTarget.getAttribute('data-locale')

  initialize: ({ @onChange }) ->
    @listenTo @model, 'change:prefs.locale', @render

  selectLocale: (newLocale) ->
    oldLocale = @model.getPref('locale')
    @model.setPref 'locale', newLocale, =>
      @onChange(newLocale, oldLocale)
    return

  render: ->
    currentLocale = @model.getLocale()

    langChoice = (locale, text) ->
      t.li ->
        t.a '.js-select-locale', { href: '#', 'data-locale': locale }, ->
          t.text text
          if locale == currentLocale
            t.text ' '
            t.icon 'check'
          return
        return
      return

    @$el.html t.render ->
      t.ul '.pop-over-list', ->
        for { code, name } in supportedLocales
          normalizedCode = Language.normalizeLocale(code)
          langChoice normalizedCode, name
        return
    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-locale-view.coffee